var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{ref:"input",staticClass:"form-control",attrs:{"type":"password"},domProps:{"value":_vm.myValue},on:{"change":_vm.updateValue,"input":_vm.inputValue,"blur":_vm.updateValue}})])}
var staticRenderFns = []

export { render, staticRenderFns }